export default function UpcomingEvents() {
  const events = [
    {
      title: 'Private Venue Takeover',
      location: 'Yaletown',
      description: "Members-only takeover of Vancouver's most exclusive lounge. Premium bottle service, private DJ, and strictly curated door policy. The city's most connected gather for an unforgettable night.",
      image: 'https://public.readdy.ai/ai/img_res/c60398e083264c471079963fc2a2f248.jpg',
      type: 'Exclusive'
    },
    {
      title: 'Yacht Social',
      location: 'Coal Harbour',
      description: 'Exclusive sunset yacht experience departing from Coal Harbour. Premium open bar, curated guest list, and panoramic views of the North Shore mountains.',
      image: 'https://readdy.ai/api/search-image?query=luxury%20yacht%20party%20at%20golden%20sunset%20with%20champagne%20glasses%20and%20bottles%20on%20teak%20deck%20warm%20romantic%20orange%20pink%20lighting%20intimate%20atmosphere%20elegant%20nautical%20setting%20premium%20yacht%20furniture%20city%20skyline%20background%20no%20people%20empty%20deck%20sophisticated%20coastal%20vibes&width=800&height=600&seq=yacht-party-champagne-sunset-012&orientation=landscape',
      type: 'Experience'
    },
    {
      title: 'Luxury Rooftop Social',
      location: 'Downtown Vancouver',
      description: "Premium members-only event at one of Vancouver's premier rooftop venues with panoramic city views.",
      image: 'https://readdy.ai/api/search-image?query=rooftop%20bar%20at%20sunset%20with%20city%20lights%20twinkling%20below%20warm%20golden%20hour%20lighting%20intimate%20lounge%20seating%20sophisticated%20outdoor%20furniture%20downtown%20skyline%20panoramic%20view%20elegant%20fire%20features%20premium%20atmosphere%20no%20people%20empty%20venue%20evening%20ambiance%20luxury%20terrace&width=800&height=600&seq=rooftop-bar-sunset-citylights-013&orientation=landscape',
      type: 'Views'
    },
    {
      title: 'Mansion Party',
      location: 'West Vancouver',
      description: 'Private social gathering at a luxury residence with curated guest list and premium atmosphere.',
      image: 'https://readdy.ai/api/search-image?query=west%20vancouver%20luxury%20mansion%20interior%20at%20night%20with%20floor%20to%20ceiling%20windows%20overlooking%20ocean%20and%20city%20lights%20modern%20coastal%20architecture%20sophisticated%20elegant%20design%20warm%20ambient%20lighting%20marble%20floors%20contemporary%20furniture%20mountain%20and%20water%20views%20through%20glass%20walls%20no%20people%20empty%20living%20space%20premium%20west%20coast%20aesthetic&width=800&height=600&seq=west-van-mansion-ocean-view-016&orientation=landscape',
      type: 'Social'
    },
    {
      title: 'Sponsored Brand Event',
      location: 'Gastown',
      description: 'Private brand partnership events with free products, sponsorship opportunities, and premium experiences.',
      image: 'https://readdy.ai/api/search-image?query=sleek%20modern%20art%20gallery%20event%20space%20with%20contemporary%20art%20installations%20minimalist%20white%20walls%20sophisticated%20lighting%20design%20premium%20exhibition%20venue%20clean%20aesthetic%20high%20ceilings%20polished%20concrete%20floors%20no%20people%20empty%20gallery%20upscale%20atmosphere&width=800&height=600&seq=gallery-modern-space-005&orientation=landscape',
      type: 'Brand Event'
    },
    {
      title: 'Members-Only Dinner',
      location: 'Downtown Vancouver',
      description: 'Intimate private dinner at top tier restaurant with members to connect.',
      image: 'https://readdy.ai/api/search-image?query=private%20chef%20table%20with%20candlelight%20in%20luxury%20restaurant%20intimate%20dim%20lighting%20elegant%20long%20dining%20table%20dark%20wood%20paneling%20leather%20chairs%20sophisticated%20fine%20dining%20interior%20moody%20atmospheric%20setting%20no%20people%20empty%20table%20premium%20high-end%20aesthetic%20warm%20glow&width=800&height=600&seq=private-chef-candlelight-luxury-015&orientation=landscape',
      type: 'Private'
    }
  ];

  return (
    <section className="bg-gray-50 px-6 py-32">
      <div className="mx-auto max-w-7xl">
        <div className="mb-16 text-center">
          <div className="mb-6 h-px w-24 mx-auto bg-gradient-to-r from-transparent via-amber-400 to-transparent" />
          <h2 className="mb-6 font-serif text-4xl font-light text-black md:text-5xl lg:text-6xl">
            Upcoming <span className="italic">Events</span>
          </h2>
          <p className="text-lg text-gray-600">
            A glimpse into Clique's calendar
          </p>
        </div>

        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {events.map((event, index) => (
            <div 
              key={index}
              className="group overflow-hidden border border-gray-200 bg-white transition-all duration-300 hover:border-amber-400 hover:shadow-2xl cursor-pointer"
            >
              <div className="relative h-64 overflow-hidden">
                <img 
                  src={event.image}
                  alt={event.title}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute right-4 top-4 bg-black px-4 py-2 text-xs font-medium tracking-widest text-white">
                  {event.type}
                </div>
              </div>
              
              <div className="p-6">
                <div className="mb-3 flex items-center gap-2 text-sm text-gray-600">
                  <i className="ri-map-pin-line"></i>
                  <span>{event.location}</span>
                </div>
                
                <h3 className="mb-3 text-xl font-medium text-black">
                  {event.title}
                </h3>
                
                <p className="leading-relaxed text-gray-600">
                  {event.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 border-l-4 border-amber-400 bg-white p-8 text-center md:p-12">
          <p className="text-xl text-gray-700">
            <span className="font-medium text-black">Members-only access.</span> These events are available only to approved Clique members. Apply today to unlock your invitation.
          </p>
        </div>
      </div>
    </section>
  );
}
